import type { FloatPrice, IntPrice } from "@/types";
import Decimal from "decimal.js";

/**
 * Converts an integer price (backend format) to a float price (display format)
 * by dividing by 1 million, using Decimal.js for precise calculations.
 *
 * @param price - The integer price value to convert (backend format)
 * @returns The float price value (display format)
 */
export function convertIntToFloatPrice(price: IntPrice): FloatPrice {
    const decimalPrice = new Decimal(price);
    const million = new Decimal(1_000_000);
    return decimalPrice.dividedBy(million).toNumber() as FloatPrice;
}
